/** @jsx h */
import { h } from 'preact'

import ModalCardHeader from './Header'
import ExternalLink from '../ExternalLink'
import t from '../../../utils/translate'

const VerifierSection = ({ analyticsContext, name, logoUrl, description, schemeUrl, claimStatus, validUntil }) =>
  <section class='ModalCard-section'>
    <ModalCardHeader title={name} imageUrl={logoUrl} variant='scheme' claimStatus={claimStatus} />

    <p class='ModalCard-para u-marginTop16'>{description}</p>

    <p class='ModalCard-para u-marginTop8'>
      {t('proof_points.js.valid_until')} <span>{validUntil}</span>
    </p>

    <ExternalLink href={schemeUrl} className='u-marginTop16' linkName='View scheme' analyticsContext={analyticsContext}>
      {t('proof_points.js.certificates.view_scheme')}
    </ExternalLink>
  </section>

export default VerifierSection
